<template>
  <div class="d-flex align-items-center" @click="handleUserClick">
    <div class="avatar mr-3">
      <img
        :src="user.profilePic"
        alt="user-profile-picture"
        class="avatar-50 rounded"
      />
    </div>
    <div class="chat-sidebar-name">
      <h6 class="mb-0">{{ user.firstName }} {{ user.lastName }}</h6>
      <span class="muted-text">{{ user.email }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatItem",
  props: ["user"],
  methods: {
    handleUserClick() {
      this.$emit("userClicked", this.user);
    },
  },
};
</script>
